import React from "react";
import {Row, Col, DatePicker, Input} from "antd";
const {RangePicker} = DatePicker;

export const MerchantSummaryFilter = ({filters, setFilters, datePickerProps}) => {
    return (
        <Row gutter={[16, 16]}>
            <Col xs={24} sm={12} md={10} lg={8} xl={8} style={{marginBottom: 16, marginRight: 16}}>
                <div style={{marginBottom: 4, fontWeight: 500}}>Tarih Aralığı</div>
                <RangePicker {...datePickerProps} style={{minWidth: 300, width: "100%"}} />
            </Col>
            <Col xs={24} sm={12} md={7} lg={6} xl={6} style={{marginBottom: 16}}>
                <div style={{marginBottom: 4, fontWeight: 500}}>Alıcı Adı / Fiş No</div>
                <Input
                    placeholder="Alıcı adı / Fiş No"
                    value={filters.receiverName || ""}
                    onChange={e => setFilters({...filters, receiverName: e.target.value})}
                    allowClear
                />
            </Col>
            <Col xs={24} sm={12} md={7} lg={6} xl={6}>
                <div style={{marginBottom: 4, fontWeight: 500}}>Sipariş No</div>
                <Input
                    placeholder="Sipariş No"
                    value={filters.vigoOrderNumber || ""}
                    onChange={e => setFilters({...filters, vigoOrderNumber: e.target.value})}
                    allowClear
                />
            </Col>
        </Row>
    );
};
